import React from "react";
import { Modal, Button } from "react-bootstrap";

const LeaveWhileProcessingModal = ({ show, onHide, onConfirm }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="pt-0">
        <Modal.Header className="modal-title-with-border mb-0" closeButton>
          <Modal.Title className="fw-bold">Leave while processing?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            Your template is still processing.
            <br />
            Leaving now may interrupt the process.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            Leave Anyway
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default LeaveWhileProcessingModal;
